"use strict";
exports.__esModule = true;
function getRatio() {
    return window.devicePixelRatio ? window.devicePixelRatio : 2;
}
exports["default"] = getRatio;
//# sourceMappingURL=get-ratio.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/dom-util/lib/get-ratio.js
// module id = 795
// module chunks = 37